import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../common.service';
import { ToastrService } from 'ngx-toastr';
import { DefaultComponent } from '../../layout/default/default.component';
import { News } from './news';
declare var $: any;
@Component({
  selector: 'app-shubh-divas-add',
  templateUrl: './shubh-divas-add.component.html',
  styleUrls: ['./shubh-divas-add.component.css']
})
export class ShubhDivasAddComponent implements OnInit {
  imageURL1: string;
  news_date = localStorage.getItem('EntryDate');
  name = 'ng2-ckeditor';
  ckeConfig: any;
  content1: string;
  bhag_no: any = '';
  log: string = '';
  NewsData: any = [];
  news_id: any = 0;
  NewsImageURL = environment.baseUrl;
  imageURL: string;
  @ViewChild("myckeditor") ckeditor: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public toastr: ToastrService,
    public CommonService: CommonService,
    public DefaultComponent: DefaultComponent
  ) {
    this.DefaultComponent.loaderShow();
    this.route.params.subscribe(params => this.news_id = params.news_id);
    var param = { news_id: this.news_id };
    if (this.news_id) {
      this.CommonService.getAajNaDivseDetail(param).subscribe((data) => {
        this.DefaultComponent.loaderHide();
        if (data['status']) {
          this.NewsData = data['divse_data']
          if (this.NewsData.image != '') {
            this.imageURL = this.NewsImageURL + '/aaj_na_divse/' + this.NewsData.image;
          }
          this.content1 = this.NewsData.content;
        } else {
          if (data.token_expire) {
            localStorage.removeItem('login_token');
            this.router.navigate(['/']);
          } else {
            this.router.navigate(['/dashboard']);
          }
        }
      });
    } else {
      this.content1 = '';
      var parameter = { 'entry_date': localStorage.getItem('EntryDate') };
      this.NewsData.title = 'આજના શુભ દિવસે -';
      this.CommonService.GetAajNaDivseLastDisplayOrder(parameter).subscribe((data) => {
        if (data.status) {
          this.bhag_no = data.bhag_no;
          $("#display_order").val(data.display_order);
          $("#oriDisplayOrder").val(0);
        } else {
          if (data.token_expire) {
            localStorage.removeItem('login_token');
            this.router.navigate(['/']);
          }
        }
        this.DefaultComponent.loaderHide();
      });
    }
  }
  imageValidation(event, id) {
    const file = (event.target as HTMLInputElement).files[0];
    var mimeType = file.type;
    if (mimeType.match(/image\/*/) == null) {
      $("#image" + id).val('');
      this.toastr.error("Only image are supported.");
      return;
    }
  }
  submit_form() {
    var routers = this.router;
    var th = this;
    $.validate({
      onSuccess: function () {
        th.DefaultComponent.loaderShow();
        //$('.btn-success').attr('disabled', true);
        var form = $("#aaj_na_divse_form");
        var fd = new FormData(form[0]);
        fd.append('content', th.content1);
        var token = localStorage.getItem('login_token');
        $.ajax({
          url: environment.AajNaDivseBaseUrl + 'add_aaj_na_divse',
          method: 'POST',
          data: fd,
          headers: {
            'Authorization': token
          },
          contentType: false,
          processData: false,
          dataType: 'json',
          success: function (res) {
            th.DefaultComponent.loaderHide();
            if (res.status) {
              th.toastr.success(res.message)
              routers.navigate(['/shubh-divas-list']);
            } else {
              if (res.token_expire) {
                localStorage.removeItem('login_token');
                routers.navigate(['/']);
              }
              else {
                th.toastr.error(res.message)
              }
            }
            $('.btn-success').attr('disabled', false);
          }
        });
        return false;
      }
    });
  }
  ngOnInit(): void {
    this.ckeConfig = {
      // allowedContent: true,
      toolbarGroups: [
        { name: 'document', groups: ['mode'] },
        { name: 'basicstyles', groups: ['basicstyles'] },
        {
          name: 'paragraph',
          groups: ['list', 'align', 'paragraph']
        },
        { name: 'styles', groups: ['styles'] },
        { name: 'colors', groups: ['colors'] },
      ],
      extraPlugins:
        'basicstyles,bidi,blockquote,clipboard,' +
        'button,panelbutton,panel,floatpanel,colorbutton,colordialog,menu,' +
        'contextmenu,dialogadvtab,div,elementspath,enterkey,entities,popup,' +
        'filebrowser,find,fakeobjects,floatingspace,listblock,richcombo,' +
        'font,format,forms,horizontalrule,htmlwriter,iframe,image,indent,' +
        'indentblock,indentlist,justify,link,list,liststyle,magicline,' +
        'maximize,pagebreak,pastefromword,pastetext,' +
        'resize,menubutton,scayt,selectall,showblocks,' +
        'showborders,smiley,sourcearea,specialchar,stylescombo,tab,table,' +
        'tabletools,templates,toolbar,undo,wysiwygarea',
    };
    //   allowedContent: true,
    //   toolbarGroups: [{
    //     name: 'document',
    //     groups: ['mode', 'document', 'doctools']
    //   },
    //   {
    //     name: 'clipboard',
    //     groups: ['clipboard', 'undo']
    //   },
    //   {
    //     name: 'editing',
    //     groups: ['find', 'selection', 'spellchecker', 'editing']
    //   },
    //   {
    //     name: 'forms',
    //     groups: ['forms']
    //   },
    //     '/',
    //   {
    //     name: 'paragraph',
    //     groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph']
    //   },
    //   {
    //     name: 'links',
    //     groups: ['links']
    //   },
    //   {
    //     name: 'insert',
    //     groups: ['insert']
    //   },
    //     '/',
    //   {
    //     name: 'styles',
    //     groups: ['styles']
    //   },
    //   {
    //     name: 'basicstyles',
    //     groups: ['basicstyles', 'cleanup']
    //   },
    //   {
    //     name: 'colors',
    //     groups: ['colors']
    //   },
    //   {
    //     name: 'tools',
    //     groups: ['tools']
    //   },
    //   {
    //     name: 'others',
    //     groups: ['others']
    //   },
    //   {
    //     name: 'about',
    //     groups: ['about']
    //   }
    //   ],
    //   removeButtons: 'ExportPdf,Form,Checkbox,Radio,TextField,Select,Textarea,Button,ImageButton,HiddenField,NewPage,CreateDiv,Flash,Iframe,About,ShowBlocks,Maximize',
    //   // This is optional, but will let us define multiple different styles for multiple editors using the same CSS file.
    //   bodyClass: 'document-editor'
    // };
  }
  onChange($event: any): void {
    console.log("onChange");
    //this.log += new Date() + "<br />";
  }
  onPaste($event: any): void {
    console.log("onPaste");
    //this.log += new Date() + "<br />";
  }
}
